export default "/images/AlbertoAmbrosio.jpg?80df131042b9642a412a86818fbccbe7";